import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-base-layout',
    templateUrl: './base-layout.component.html',
    styleUrls: ['./base-layout.component.scss'],
    standalone: false
})
export class BaseLayoutComponent {
  constructor() { }
}
